var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_946_4197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3184 15C30.3184 6.71572 23.6026 0 15.3184 0C7.03408 0 0.318359 6.71572 0.318359 15C0.318359 22.4869 5.80364 28.6925 12.9746 29.8178V19.3359H9.16602V15H12.9746V11.6953C12.9746 7.93594 15.214 5.85938 18.6403 5.85938C20.2815 5.85938 21.998 6.15234 21.998 6.15234V9.84375H20.1066C18.2432 9.84375 17.6621 11 17.6621 12.1862V15H21.8223L21.1572 19.3359H17.6621V29.8178C24.8331 28.6925 30.3184 22.4869 30.3184 15Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1572 19.3359L21.8223 15H17.6621V12.1862C17.6621 11 18.2432 9.84375 20.1066 9.84375H21.998V6.15234C21.998 6.15234 20.2815 5.85938 18.6403 5.85938C15.214 5.85938 12.9746 7.93594 12.9746 11.6953V15H9.16602V19.3359H12.9746V29.8178C13.7383 29.9376 14.521 30 15.3184 30C16.1157 30 16.8984 29.9376 17.6621 29.8178V19.3359H21.1572Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_946_4197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.318359)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.00f4fe236ecb64633c1bc051923ec0d5.svg";
export { ForwardRef as ReactComponent };